module.exports = __webpack_public_path__ + "img/10.d6e3e4d4.jpg";